export enum ACCESS_RIGHTS {
  OWNER = 'OWNER',
  ADMINISTRATOR = 'ADMINISTRATOR',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  SUPERVISOR = 'SUPERVISOR',
  TECHNICAL = 'TECHNICAL',
  AGENT = 'AGENT',
  SELLER = 'SELLER',
}

export const SELECTABLE_ACCESS_RIGHTS: ACCESS_RIGHTS[] = [
  ACCESS_RIGHTS.OWNER,
  ACCESS_RIGHTS.MANAGER,
  ACCESS_RIGHTS.ADMINISTRATOR,
  ACCESS_RIGHTS.AGENT,
];

export enum GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHERS',
  UNKOWN = 'UNKNOWN',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum POLICY_DOCUMENT_TYPES {
  ID_CARD = 'ID_CARD',
  OWNER_PHOTO = ' OWNER_PHOTO',
  DRIVER_LICENSE_BACK = 'DRIVER_LICENSE_BACK',
  DRIVER_LICENSE_FRONT = 'DRIVER_LICENSE_FRONT',
  STAFF_ID = 'STAFF_ID',
  PAYSLIP = 'PAYSLIP',
  OTHER = 'OTHER',
  INSURANCE_STICKER = 'INSURANCE_STICKER',
  INSURANCE_CERTIFICATE = 'INSURANCE_CERTIFICATE',
  CONTRACT_SUMMARY = 'CONTRACT_SUMMARY',
  PAYMENT_AGREEMENT = 'PAYMENT_AGREEMENT',
  LOAN_AGREEMENT = 'LOAN_AGREEMENT',
  PAYMENT_LOAN_AGREEMENT = 'PAYMENT_LOAN_AGREEMENT',
  PASSPORT_PHOTO = 'PASSPORT_PHOTO',
  POLICY_STICKER = 'POLICY_STICKER',
  POLICY_SCHEDULE = 'POLICY_SCHEDULE',
  ROADWORTHY_CERTIFICATE = 'ROADWORTHY_CERTIFICATE',
  ROADWORTHY = 'ROADWORTHY',
  RENEWAL_NOTICE = 'RENEWAL_NOTICE',
  VEHICLE_PHOTO_FRONT = 'VEHICLE_PHOTO_FRONT',
  VEHICLE_PHOTO_BACK = 'VEHICLE_PHOTO_BACK',
  VEHICLE_PHOTO_LEFT = 'VEHICLE_PHOTO_LEFT',
  VEHICLE_PHOTO_RIGHT = 'VEHICLE_PHOTO_RIGHT',
  POLICY = 'POLICY'
}

export enum VERIFIED_VEHICLE_DOCUMENT_TYPES {
  ID_CARD = 'ID_CARD',
  OWNER_PHOTO = ' OWNER_PHOTO',
  DRIVER_LICENSE_BACK = 'DRIVER_LICENSE_BACK',
  DRIVER_LICENSE_FRONT = 'DRIVER_LICENSE_FRONT',
  STAFF_ID = 'STAFF_ID',
  OTHER = 'OTHER',
  PASSPORT_PHOTO = 'PASSPORT_PHOTO',
  VEHICLE_PHOTO_FRONT = 'VEHICLE_PHOTO_FRONT',
  VEHICLE_PHOTO_BACK = 'VEHICLE_PHOTO_BACK',
  VEHICLE_PHOTO_LEFT = 'VEHICLE_PHOTO_LEFT',
  VEHICLE_PHOTO_RIGHT = 'VEHICLE_PHOTO_RIGHT',
  INSPECTION_REPORT = 'INSPECTION_REPORT'
}

export enum INSTALLMENT_TYPE {
  FULL_PAYMENT = 'FULL_PAYMENT',
  WEEKLY_PAYMENT = 'WEEKLY_PAYMENT'
}

export enum DISCOUNT_TYPES {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export enum INSTALLMENT_TYPES {
  FULL_PAYMENT = 'FULL_PAYMENT',
  TWELVE_MONTHS = 'TWELVE_MONTHS',
  NINE_MONTHS = 'NINE_MONTHS',
  SIX_MONTHS = 'SIX_MONTHS',
  THREE_MONTHS = 'THREE_MONTHS',
  TWELVE_WEEKS = 'TWELVE_WEEKS',
  TEN_WEEKS = 'TEN_WEEKS',
  NINE_WEEKS = 'NINE_WEEKS',
  ONE_HUNDRED_AND_TWENTY_DAYS = 'ONE_HUNDRED_AND_TWENTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS',
  SEVENTY_DAYS = 'SEVENTY_DAYS',
  SIXTY_FIVE_DAYS = 'SIXTY_FIVE_DAYS',
  FIFTY_FIVE_DAYS = 'FIFTY_FIVE_DAYS',
  SIXTY_DAYS = 'SIXTY_DAYS',
  FORTY_DAYS = 'FORTY_DAYS',
  THREE_DAYS_TEST = 'THREE_DAYS_TEST',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY'
}

export enum COVER_PERIODS {
  ONE_YEAR = 12,
  NINE_MONTHS = 9,
  SIX_MONTHS = 6,
  THREE_MONTHS = 3
}

export enum POLICY_STATUS_OPTIONS {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum DISCOUNT_STATUS_OPTIONS {
  TRUE = 'Active',
  FALSE = 'Inactive'
}

export enum SALES_STATUS {
  PAID = 'PAID',
  UNPAID = 'UNPAID'
}

export enum DISCOUNT_RELATION_OPTIONS {
  ONE_TIME = 'ONE TIME',
  INITIAL_DEPOSIT = 'INITIAL DEPOSIT',
  MONTHLY_INSTALLMENTS = 'MONTHLY INSTALLMENTS'
}

export enum INSURER_STATUS_OPTIONS {
  TRUE = 'ACTIVE',
  FALSE = 'INACTIVE'
}

export enum ADMIN_POLICY_STATUS_ACTIONS {
  DUE_LATER = 'DUE_LATER',
  APPROVE = 'APPROVE',
  HOLD = 'HOLD',
  REJECT = 'REJECT'
}

export enum POLICY_REVIEW_STATES {
  NEW = 'NEW',
  DRAFT = 'DRAFT',
  ON_HOLD = 'ON_HOLD',
  DUE_LATER = 'DUE_LATER',
  IN_APPROVAL = 'IN_APPROVAL',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  IN_REVIEW = 'IN_REVIEW',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED',
  // Not a persisted backend reviewStage — "Pending Approval" is the derived
  // state (NEW/DRAFT/DECLINED + firstPaymentReceived). Used only as a UI
  // filter sentinel; the list translates it into the API's pendingApproval
  // flag rather than sending it as reviewStage.
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  // Also not a persisted reviewStage — "Existing" is the bulk-imported book.
  // UI filter sentinel; the list translates it into the API's `existing` flag.
  EXISTING = 'EXISTING'
}

export enum CLAIM_REVIEW_STATES {
  NEW = 'NEW',
  ON_HOLD = 'ON_HOLD',
  DUE_LATER = 'DUE_LATER',
  IN_APPROVAL = 'IN_APPROVAL',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  IN_REVIEW = 'IN_REVIEW',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED'
}

export enum RNPL_REVIEW_STATES {
  NEW = 'NEW',
  IN_REVIEW = 'IN_REVIEW',
  IN_APPROVAL = 'IN_APPROVAL',
  ON_HOLD = 'ON_HOLD',
  DUE_LATER = 'DUE_LATER',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED'
}

export enum PREMIUM_FINANCING_REVIEW_STATES {
  NEW = 'NEW',
  IN_REVIEW = 'IN_REVIEW',
  IN_APPROVAL = 'IN_APPROVAL',
  ON_HOLD = 'ON_HOLD',
  DUE_LATER = 'DUE_LATER',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED',
  APPROVED = 'APPROVED'
}

export enum INSURANCE_TYPE {
  COMPREHENSIVE = 'Comprehensive',
  THIRD_PARTY = 'Third Party'
}

export enum LEAD_STATUS {
  COLD = 'COLD',
  WARM = 'WARM',
  CLOSED = 'CLOSED',
  PAID = 'PAID'
}

export enum LEAD_TAGS {
  NEW = 'NEW',
  CONTACTED = 'CONTACTED',
  QUALIFIED = 'QUALIFIED',
  UNRESPONSIVE = 'UNRESPONSIVE',
  DISQUALIFIED = 'DISQUALIFIED',
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  NURTURING = 'NURTURING',
  CONVERTED = 'CONVERTED'
}

export enum LEAD_TAGS_COLD {
  NEW = 'NEW',
  CONTACTED = 'CONTACTED',
  QUALIFIED = 'QUALIFIED',
  UNRESPONSIVE = 'UNRESPONSIVE',
  DISQUALIFIED = 'DISQUALIFIED'
}

export enum LEAD_TAGS_WARM {
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  NURTURING = 'NURTURING'
}

export enum LEAD_TAGS_CLOSED {
  CONVERTED = 'CONVERTED'
}

export enum VEHICLE_BODY_TYPES {
  SUV = 'SUV',
  CONVERTIBLE = 'CONVERTIBLE',
  HATCHBACK = 'HATCHBACK',
  STATION_WAGON = 'STATION_WAGON',
  COUPE = 'COUPE',
  VAN = 'VAN',
  PICKUP = 'PICKUP',
  SALOON_SEDAN = 'SALOON_SEDAN',
  MINI_SMALL_BUS = 'MINI_SMALL_BUS',
  MAXI_BIG_BUS = 'MAXI_BIG_BUS',
  SPORT_CAR = 'SPORTS_CAR',
  ARTICULATED_TRUCK = 'ARTICULATED_TRUCK',
  MOTOR_BIKE = 'MOTORCYCLE',
  SEDAN = 'SEDAN',
  WAGON = 'WAGON',
  CROSSOVER = 'CROSSOVER',
  MINIVAN = 'MINIVAN',
  LUXURY_SEDAN = 'LUXURY_SEDAN',
  SPORTS_CAR = 'SPORTS_CAR',
  SUPERCAR = 'SUPERCAR',
  HYPERCAR = 'HYPERCAR',
  LIFTBACK = 'LIFTBACK',
  NOTCHBACK = 'NOTCHBACK',
  FASTBACK = 'FASTBACK',
  TARGA_TOP = 'TARGA_TOP',
  PHAETON = 'PHAETON',

  PICKUP_TRUCK_LIGHT = 'PICKUP_TRUCK_LIGHT',
  PICKUP_TRUCK_HEAVY = 'PICKUP_TRUCK_HEAVY',
  BOX_TRUCK = 'BOX_TRUCK',
  FLATBED_TRUCK = 'FLATBED_TRUCK',
  DUMP_TRUCK = 'DUMP_TRUCK',
  SEMI_TRUCK = 'SEMI_TRUCK',

  PANEL_VAN = 'PANEL_VAN',
  CARGO_VAN = 'CARGO_VAN',
  STEP_VAN = 'STEP_VAN',
  DELIVERY_VAN_SMALL = 'DELIVERY_VAN_SMALL',
  SERVICE_TRUCK = 'SERVICE_TRUCK',
  TOW_TRUCK = 'TOW_TRUCK',
  FIRE_TRUCK = 'FIRE_TRUCK',
  AMBULANCE = 'AMBULANCE',
  GARBAGE_TRUCK = 'GARBAGE_TRUCK',
  TANKER_TRUCK = 'TANKER_TRUCK',
  CONCRETE_MIXER_TRUCK = 'CONCRETE_MIXER_TRUCK',
  LOGGING_TRUCK = 'LOGGING_TRUCK',

  BUS_PASSENGER = 'BUS_PASSENGER',
  SCHOOL_BUS = 'SCHOOL_BUS',
  MOTORCOACH = 'MOTORCOACH',
  ARTICULATED_BUS = 'ARTICULATED_BUS',
  MINIBUS = 'MINIBUS',
  PASSENGER_VAN = 'PASSENGER_VAN',
  CONVERSION_VAN = 'CONVERSION_VAN',
  CAMPER_VAN = 'CAMPER_VAN',
  RV_CLASS_A = 'RV_CLASS_A',
  RV_CLASS_C = 'RV_CLASS_C',
  MOTORHOME = 'MOTORHOME',
  LIMOUSINE = 'LIMOUSINE',

  AMPHIBIOUS_VEHICLE = 'AMPHIBIOUS_VEHICLE',
  DUNE_BUGGY = 'DUNE_BUGGY',
  GO_KART = 'GO_KART',
  ATV = 'ATV',
  UTV = 'UTV',
  SNOWMOBILE = 'SNOWMOBILE',
  GOLF_CART = 'GOLF_CART',
  TRACKED_VEHICLE = 'TRACKED_VEHICLE',
  HEARSE = 'HEARSE',

  MOTORCYCLE_STANDARD = 'MOTORCYCLE_STANDARD',
  MOTORCYCLE_CRUISER = 'MOTORCYCLE_CRUISER',
  MOTORCYCLE_SPORT = 'MOTORCYCLE_SPORT',
  MOTORCYCLE_TOURING = 'MOTORCYCLE_TOURING',
  MOTORCYCLE_DUAL_SPORT = 'MOTORCYCLE_DUAL_SPORT',
  MOTORCYCLE_DIRT = 'MOTORCYCLE_DIRT',
  MOTORCYCLE_CHOPPER = 'MOTORCYCLE_CHOPPER',
  SIDECAR_MOTORCYCLE = 'SIDECAR_MOTORCYCLE',
  SCOOTER = 'SCOOTER',
  MOPED = 'MOPED',
  TRIKE = 'TRIKE',

  ELECTRIC_CAR = 'ELECTRIC_CAR',
  HYBRID_CAR = 'HYBRID_CAR',
  CLASSIC_CAR = 'CLASSIC_CAR',
  CUSTOM_BUILD = 'CUSTOM_BUILD',
  CONCEPT_CAR = 'CONCEPT_CAR',
  RACE_CAR = 'RACE_CAR',
  NEV = 'NEV',
  AUTOCYCLE = 'AUTOCYCLE',

  CRANE = 'CRANE',
  EXCAVATOR = 'EXCAVATOR',
  FORKLIFT = 'FORKLIFT',
  HAMMERHEAD = 'HAMMERHEAD',
  HILUX = 'HILUX',
  BULLDOZER = 'BULLDOZER'
}

export enum ID_TYPES_DTO {
  PASSPORT = 'PASSPORT',
  NATIONAL_ID = 'NATIONAL_ID',
  VOTER_ID = 'VOTER_ID',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  SOCIAL_SECURITY = 'SOCIAL_SECURITY',
  TIN = 'TIN'
}

export enum VEHICLES_MAKE {
  HYUNDAI = 'Hyundai',
  TOYOTA = 'Toyota',
  MERCEDEZ = 'Mercedez',
  BMW = 'BMW',
  AUDI = 'Audi',
  HONDA = 'Honda',
  CHEVROLET = 'Chevrolet',
  CADILLAC = 'Cadillac',
  FERRARI = 'Ferrari',
  FORD = 'Ford',
  TATA = 'Tata'
}

export enum LEAD_SOURCE {
  ASEMPA_FM = 'ASEMPA_FM',
  BOLT_APP = 'BOLT_APP',
  CITI_FM = 'CITI_FM',
  CITIFM_ONLINE = 'CITIFM_ONLINE',
  CUSTOMER_REFERRAL = 'CUSTOMER_REFERRAL',
  DIRECT_SALES = 'DIRECT_SALES',
  FACEBOOK = 'FACEBOOK',
  GHANA_WEB = 'GHANAWEB',
  GOOGLE_BUSINESS = 'GOOGLE_BUSINESS',
  INSTAGRAM = 'INSTAGRAM',
  JOY_FM = 'JOY_FM',
  LINKEDIN = 'LINKEDIN',
  MYJOY_ONLINE = 'MYJOY_ONLINE',
  OTHER = 'OTHER',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  TEAM_DIRECT = 'TEAM_DIRECT',
  TIKTOK = 'TIKTOK',
  WEBSITES_OR_BLOGS = 'WEBSITES_OR_BLOGS',
  WHATSAPP = 'WHATSAPP',
  YANGO_APP = 'YANGO_APP'
}

export enum ADMIN_USER_ROLES {
  SUPER = 'SUPER',
  SUPER_ADMINISTRATOR = 'SUPER_ADMINISTRATOR',
  ADMINISTRATOR = 'ADMINISTRATOR',
  AGENT = 'AGENT'
}

export enum ADMIN_PAYMENTS_STATUS_FILTER_OPTIONS {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  OVERDUE = 'OVERDUE'
}

export enum CLAIM_STAGES {
  NEW = 'NEW',
  IN_REVIEW = 'IN_REVIEW',
  SUBMITTED = 'SUBMITTED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ASSESSED = 'ASSESSED',
  ADJUSTED = 'ADJUSTED',
  DV_ISSUED = 'DV_ISSUED',
  DV_SIGNED = 'DV_SIGNED',
  PAID = 'PAID'
}

export enum COMPANY_TYPES {
  INTERNAL = 'INTERNAL',
  AGENCY = 'AGENCY',
  REPAIR_CENTER = 'REPAIR_CENTER',
  INSURER = 'INSURER',
  RIDE_SHARING = 'RIDE_SHARING',
  AFFILIATE = 'AFFILIATE',
  FLEET = 'FLEET',
  FUEL_PROVIDER = 'FUEL_PROVIDER',
  FINANCIER = 'FINANCIER',
  BROKER = 'BROKER',
  OTHER = 'OTHER'
}

export enum PARTNER_TYPES {
  REPAIR_CENTER = 'REPAIR_CENTER',
  INSURER = 'INSURER',
  RIDE_SHARING = 'RIDE_SHARING',
  AFFILIATE = 'AFFILIATE',
  FLEET = 'FLEET',
  FUEL_PROVIDER = 'FUEL_PROVIDER',
  FINANCIER = 'FINANCIER',
  BROKER = 'BROKER',
  AGENCY = 'AGENCY',
  OTHER = 'OTHER'
}

export enum CLIENTS_TYPES {
  RIDE_SHARING = 'RIDE_SHARING',
  FLEET = 'FLEET',
}

export enum PAYMENT_STATUS_STATES {
  CREATED = 'CREATED',
  SUCCESS = 'SUCCESS',
  REJECTED = 'REJECTED',
  VOID = 'VOID',
  PENDING = 'PENDING',
  OVERDUE = 'OVERDUE',
  LONG_OVERDUE = 'LONG_OVERDUE',
  APPROVAL = 'APPROVAL',
  MISSED = 'MISSED'
}

export enum POLICY_STATUSES {
  ACTIVE = 'active',
  PENDING = 'pending',
  IN_REVIEW = 'in_review',
  ENDED = 'expired'
}

export enum VEHICLE_LIGHTING_TYPES {
  LOW_BEAM_DIPPED_HEADLIGHTS = 'LOW_BEAM_DIPPED_HEADLIGHTS',
  FULL_BEAM_HEADLIGHTS = 'FULL_BEAM_HEADLIGHTS',
  FOG_LIGHTS = 'FOG_LIGHTS',
  RENTAL_OR_HIRE = 'HAZARD_LIGHTS'
}

export const CAR_INSURERS_LIST = [
  'Activa International Insurance',
  'Allianz Insurance',
  'Beige Assure',
  'Best Assurance',
  'Bedrock Insurance',
  'Coronation Insurance',
  'Donewell Insurance',
  'Enterprise Life Assurance',
  'Esich Life Assurance',
  'Ghana Union Insurance',
  'Glico General Insurance',
  'Heritage Energy Insurance',
  'Hollard Insurance',
  'Imperial General Assurance',
  'Loyalty Insurance',
  'MiLife Company',
  'Millennium Insurance',
  'NSIA Insurance',
  'Priority Insurance',
  'Prudential Life Insurance',
  'Quality Insurance',
  'REGNEM Insurance',
  'Regency Nem Insurance',
  'SUNU Insurance',
  'SIC Insurance',
  'Saham Life Insurance',
  'Serene Insurance',
  'Star Assurance',
  'Starlife Insurance',
  'Vanguard Insurance',
  'Provident Insurance',
  'Prime Insurance'
];

export enum ToastType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  DEFAULT = 'default'
}

export enum UPLOADABLE_DOCUMENT_TYPES {
  DRIVER_LICENSE_FRONT = 'DRIVER_LICENSE_FRONT',
  DRIVER_LICENSE_BACK = 'DRIVER_LICENSE_BACK',
  ID_CARD = 'ID_CARD',
  ID_CARD_BACK = 'ID_CARD_BACK',
  STAFF_ID = 'STAFF_ID',
  PAYSLIP = 'PAYSLIP',
  OTHER = 'OTHER',
  INSURANCE_STICKER = 'INSURANCE_STICKER',
  INSURANCE_CERTIFICATE = 'INSURANCE_CERTIFICATE',
  CONTRACT_SUMMARY = 'CONTRACT_SUMMARY',
  PAYMENT_AGREEMENT = 'PAYMENT_AGREEMENT',
  PASSPORT_PHOTO = 'PASSPORT_PHOTO',
  POLICY_STICKER = 'POLICY_STICKER',
  ROADWORTHY_CERTIFICATE = 'ROADWORTHY_CERTIFICATE',
  ROADWORTHY = 'ROADWORTHY',
  RENEWAL_NOTICE = ' RENEWAL_NOTICE',
  VEHICLE_PHOTO_FRONT = 'VEHICLE_PHOTO_FRONT',
  VEHICLE_PHOTO_BACK = 'VEHICLE_PHOTO_BACK',
  VEHICLE_PHOTO_LEFT = 'VEHICLE_PHOTO_LEFT',
  VEHICLE_PHOTO_RIGHT = 'VEHICLE_PHOTO_RIGHT',
  DAMAGED_VEHICLE_FRONT = 'FRONT',
  DAMAGED_VEHICLE_BACK = 'BACK',
  DAMAGED_VEHICLE_LEFT = 'LEFT',
  DAMAGED_VEHICLE_RIGHT = 'RIGHT',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  POLICY = 'POLICY',
  CLAIM = 'CLAIM',
  CLAIM_FORM = 'CLAIM_FORM',
  COVER_LETTER = 'COVER_LETTER',
  DISCHARGE_VOUCHER = 'DISCHARGE_VOUCHER',
  PAYMENT_ADVICE = 'PAYMENT_ADVICE',
  CLAIM_ESTIMATE = 'CLAIM_ESTIMATE'
}

export enum UPLOAD_IMAGE_ENDPOINTS {
  CUSTOMER = '/admin/document/customer/upload',
  VEHICLE = '/admin/document/vehicle/upload',
  POLICY = '/admin/document/policy/upload',
  STAFF = '/admin/staff/account/photo',
  INSURER_FILE = '/admin/insurers/upload',
  DOCUMENT = 'admin/document/upload',
  COMPANY = '/admin/teams/logo'
}

export enum DELETE_IMAGE_ENDPOINTS {
  INSURER_LOGO = '/admin/insurers/insurer/logo',
  INSURER_BANNER = '/admin/insurers/insurer/banner'
}

export enum PAYMENTS_FILTER_OPTIONS {
  OUTSTANDING = 'OUTSTANDING',
  OVERDUE = 'OVERDUE',
  LONG_OVERDUE = 'LONG_OVERDUE',
  PENDING = 'PENDING',
  DUE_LATER = 'DUE_LATER',
  DUE_TODAY = 'DUE_TODAY',
  DUE_THIS_WEEK = 'DUE_THIS_WEEK',
  DUE_THIS_MONTH = 'DUE_THIS_MONTH',
  SUCCESS = 'SUCCESS',
  DUE_FOR_TERMINATION = 'DUE_FOR_TERMINATION',
  MISSED = 'MISSED'
}

export enum AGENCY_PAYMENT_ACCOUNT_TYPES {
  BANK = 'BANK',
  MOBILE_MONEY = 'MOBILE_MONEY'
}

export enum PAYOUT_REVIEW_STATES {
  REQUEST = 'REQUEST',
  APPROVE = 'APPROVE',
  PAID = 'PAID'
}

export enum PAYOUT_TYPES {
  CLAIM = "CLAIM",
  COMMISSION = 'COMMISSION',
  PREMIUM = 'PREMIUM'
}

export enum MOBILE_MONEY_NETWORKS {
  MTN = 'MTN',
  VODAFONE = 'VODAFONE'
  // AIRTEL = "AIRTEL"
}

export enum CURRENCIES {
  USD = 'USD',
  GHC = 'GHC',
  EUR = 'EUR',
  NGN = 'NGN'
}

export enum COMMUNITY_TYPES {
  UNION = 'UNION',
  ASSOCIATION = 'ASSOCIATION',
  SCHOOL = 'SCHOOL',
  CHURCH = 'CHURCH',
  COMPANY = 'COMPANY',
  OTHER = 'OTHER'
}

export enum REPAIR_TYPES {
  ENGINE = 'ENGINE',
  CAR_BATTERY = 'CAR_BATTERY',
  CAR_TYRES = 'CAR_TYRES',
  BODY_WORKS_AND_SPRAYING = 'BODY_WORKS_AND_SPRAYING',
  CAR_SEATS = 'CAR_SEATS',
  OTHER = 'OTHER'
}

export enum NATURE_OF_INTERREST_OPTIONS {
  NEW_OWNER_YET_TO_CHANGE_AT_DVLA = 'NEW_OWNER_YET_TO_CHANGE_AT_DVLA',
  WORK_AND_PAY_DRIVER = 'WORK_AND_PAY_DRIVER',
  HIRE_PURCHASER = 'HIRE_PURCHASER',
  EMPLOYEE_DRIVER = 'EMPLOYEE_DRIVER',
  OTHER = 'OTHER'
}

export enum COMMUNITY_CHANNEL_OPTIONS {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export enum TRUE_FALSE {
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}

export enum YES_NO {
  YES = 'YES',
  NO = 'NO'
}

export enum POLICY_TYPES {
  AUTO = 'motor',
  HOME = 'home',
  NON_AUTO = 'non-auto',
  BUSINESS = 'business',
  TRAVEL = 'travel'
}

export enum POLICY_TYPES_PATH {
  AUTO = '/policies/?type=motor',
  HOME = '/policies/?type=home',
  NON_AUTO = '/policies/?type=non-auto',
  BUSINESS = '/policies/?type=business',
  TRAVEL = '/policies/?type=travel'
}

export enum DOWNLOAD_FILE_TYPES {
  CSV = 'CSV',
  PDF = 'PDF'
  // PHOTO = "PHOTO",
  // VIDEO = "VIDEO",
}

export enum DOWNLOAD_RESOURCE_TYPES {
  CLAIM = 'CLAIM',
  PAYOUT = 'PAYOUT',
  POLICY = 'POLICY',
  SALE = 'SALE'
}

export enum VERIFICATION_EVENT_TYPES {
  CLAIM = 'CLAIM',
  POLICY = 'POLICY'
}
export enum REDACT_INFO_TYPES {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  ADDRESS = 'ADDRESS',
  ID_NUMBER = 'ID_NUMBER',
  API_KEY = 'API_KEY',
  TOKEN = 'TOKEN',
}

export enum INSURER_FILE_TYPES {
  BANNER = 'BANNER',
  BANNER_MOBILE = 'BANNER_MOBILE',
  CSV = 'CSV',
  LOGO = 'LOGO',
  PDF = 'PDF',
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO'
}
export enum PAYMENT_PROCESSORS {
  CASH = 'CASH',
  BANK = 'BANK',
  MTN = 'MTN',
  AIRTEL_TIGO = 'AIRTEL_TIGO',
  TELECEL = 'TELECEL',
  HUBTEL = 'HUBTEL',
  IT_CONSORTIUM = 'IT_CONSORTIUM',
  PAYSTACK = 'PAYSTACK',
  FLUTTERWAVE = 'FLUTTERWAVE',
}

export enum ONLINE_PAYMENT_PROCESSORS {
  HUBTEL = 'HUBTEL',
  PAYSTACK = 'PAYSTACK',
  FLUTTERWAVE = 'FLUTTERWAVE',
  IT_CONSORTIUM = 'IT_CONSORTIUM',
}

export enum PAYMENT_CHANNELS {
  CASH = 'CASH',
  BANK = 'BANK_TRANSFER',
  MOBILE_MONEY = 'MOBILE_MONEY',
  CARD = 'CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  CHEQUE_DEPOSIT = 'CHEQUE_DEPOSIT',
  VOUCHER = 'VOUCHER',
  PREMIUM_FINANCING = 'PREMIUM_FINANCING',
}

export enum PAYMENT_CHANNELS_WITHOUT_BANK_WITHOUT_VOUCHER {
  CASH = 'CASH',
  MOBILE_MONEY = 'MOBILE_MONEY',
  CARD = 'CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  CHEQUE_DEPOSIT = 'CHEQUE_DEPOSIT',
}

export enum ENVIRONMENTS {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  TEST = 'test',
  DEV = 'dev'
}

export enum PAYMENT_RESOURCE_TYPE {
  HOME_POLICY = 'home-policy',
  AUTO_POLICY = 'auto-policy',
  HAILING_SERVICES = 'hailing-services'
}

export enum HUBTEL_RESOURCE_PAYMENT_LINKS {
  HOME_POLICY = `/home/policy/pay`,
  AUTO_POLICY = `/user/policy/pay`,
  HAILING_SERVICES = `/services/vehicle/pay/installments`
}

export enum PAYMENT_OPTIONS {
  CARD = 'CARD',
  MOBILE_MONEY = 'MOBILE_MONEY',
  BANK = 'BANK'
}

export enum DOWNLOAD_ACTION_TYPES {
  SUPER_DOWNLOAD_INSURER_POLICIES = 'SUPER_DOWNLOAD_INSURER_POLICIES',
  INSURER_DOWNLOAD_POLICIES = 'INSURER_DOWNLOAD_POLICIES',
  DOWNLOAD_PAYOUT_POLICIES = 'DOWNLOAD_PAYOUT_POLICIES',
  INSURER_DOWNLOAD_PAYOUTS = 'INSURER_DOWNLOAD_PAYOUTS',
  INSURER_DOWNLOAD_SALES = 'INSURER_DOWNLOAD_SALES'
}

export enum ACTIVITY_STREAMS_TYPE {
  TASK = 'Task',
  PAYMENT = 'Payment',
  VEHICLE = 'Vehicle',
  POLICY = 'Policy',
  CREATE = 'Create',
  UPDATE = 'Update',
  LEAD = 'Lead'
}

export enum NOTIFICATION_TYPE {
  POLICY = 'POLICY',
  TASK = 'TASK',
  LEAD = 'LEAD',
  PAYMENT = 'PAYMENT',
  QUOTE = 'QUOTE',
  COMMISSION = 'COMMISSION',
  PAYOUT = 'PAYOUT',
  CUSTOMER = 'CUSTOMER',
  CLAIM = 'CLAIM',
  COMMUNITY = 'COMMUNITY',
  TEAM = 'TEAM',
  STAFF = 'STAFF'
}

export enum APPROVAL_TYPE {
  POLICY = 'POLICY',
  LEAD = 'LEAD',
  PAYMENT = 'PAYMENT',
  QUOTE = 'QUOTE',
  COMMISSION = 'COMMISSION',
  PAYOUT = 'PAYOUT',
  CUSTOMER = 'CUSTOMER',
  CLAIM = 'CLAIM',
  COMMUNITY = 'COMMUNITY',
  TEAM = 'TEAM'
}

export enum TASK_EVENT {
  POLICY = 'POLICY',
  LEAD = 'LEAD',
  PAYMENT = 'PAYMENT',
  QUOTE = 'QUOTE',
  COMMISSION = 'COMMISSION',
  PAYOUT = 'PAYOUT',
  CUSTOMER = 'CUSTOMER',
  CLAIM = 'CLAIM',
  COMMUNITY = 'COMMUNITY',
  TEAM = 'TEAM'
}

export enum CLAIMS_VEHICLE_USAGE_TYPES {
  PRIVATE_TRIP = 'PRIVATE_TRIP',
  BUSINESS_TRIP = 'BUSINESS_TRIP',
  TRANSPORTING_BUSINESS = 'TRANSPORTING_PASSENGERS',
  TRANSPORTING_GOODS_OR_MECHANDISE = 'TRANSPORTING_GOODS_OR_MECHANDISE',
  RENTAL_OR_HIRE = 'RENTAL_OR_HIRE',
  DISPATCHING_OR_DELIVERY = 'DISPATCHING_OR_DELIVERY',
  OTHERS = 'OTHERS_(PLEASE_GIVE_DETAILS)'
}

export enum INCIDENT_REPORTED_TIME_OPTIONS {
  SAME_DAY = 'SAME_DAY',
  NEXT_DAY = 'NEXT_DAY',
  TWO_DAYS_LATER = 'TWO_DAYS_LATER',
  MORE_THAN_TWO_DAYS = 'MORE_THAN_TWO_DAYS'
}

export enum DRIVER_LICENSE_VEHICLE_GROUPS {
  MOTORCYCLES = 'Motorcycles',
  SALOON_PICKUPS_TRUCKS_SUVS = 'Saloon cars, pick-up trucks, and SUVs',
  BUSES_MEDIUM_GOODS_UP_TO_1000KG = 'Buses and medium goods - carrying vehicles(up to 1000kg)',
  BUSES_COACHES_HEAVY_GOODS_35000KG = 'Buses, coaches, heavy goods vehicles(up to 35000kg)',
  AGRIC_AND_EARTH_MOVING_EQUIPMENT = 'Agric and earth - moving equipment',
  BUSES_COACHES_TRUCKS_ABOVE_35000KG = 'Buses, coaches, trucks(above 35, 000kg)'
}

export enum TASK_STATUSES {
  NEW = 'NEW',
  DONE = 'DONE',
  IN_PROGRESS = 'IN PROGRESS',
  INAPPROVAL = 'INAPPROVAL',
  OVERDUE = 'OVERDUE'
}

export enum FUEL_SALES_STATUS {
  FAILED = 'FAILED',
  NEW = 'NEW',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
  PENDING_CLOSE = 'PENDING_CLOSE',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  PAID = 'PAID'
}

export enum FUEL_SALES_PAYMENT_MODES {
  CASH = 'CASH',
  MTN = 'MTN',
  TELECEL = 'TELECEL',
  AT = 'AT',
  GHQR = 'GHQR',
  VOUCHER = 'VOUCHER'
}

export enum RNPL_PAYMENT_CHANNEL {
  AIRTEL_TIGO = 'AIRTEL_TIGO',
  MTN = 'MTN',
  VODAFONE = 'VODAFONE'
}

export enum COUNTRIES {
  GHANA = 'Ghana',
  NIGERIA = 'Nigeria'
}

export enum SOCIAL_MEDIA_PLATFORMS {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  LINKEDIN = "LINKEDIN",
  TIKTOK = "TIKTOK",
  TWITTER = "TWITTER",
}

export enum PRODUCTS {
  AUTO_INSURANCE = 'Auto Insurance',
  HOME_INSURANCE = 'Home Insurance',
  AI_VEHICLE_VERIFICATION = 'AI Vehicle Verification',
  PREMIUM_FINANCING = 'Premium Financing'
}

export enum PRODUCT_TYPES {
  AUTO_INSURANCE = 'AUTO_INSURANCE',
  HOME_INSURANCE = 'HOME_INSURANCE',
  AI_VEHICLE_VERIFICATION = 'AI_VEHICLE_VERIFICATION',
  PREMIUM_FINANCING = 'PREMIUM_FINANCING'
}

export enum COVER_TYPES {
  COMPREHENSIVE = 'COMPREHENSIVE',
  THIRD_PARTY = 'THIRD_PARTY',
  THIRD_PARTY_FIRE_THEFT = 'THIRD_PARTY_FIRE_THEFT',
  COMPREHENSIVE_85 = 'COMPREHENSIVE_85',
  COMPREHENSIVE_90 = 'COMPREHENSIVE_90',
  COMPREHENSIVE_100 = 'COMPREHENSIVE_100',
  SMART_DRIVE = 'SMART_DRIVE'
}

export enum FORMATTED_COVER_TYPES {
  COMPREHENSIVE = 'Comprehensive',
  THIRD_PARTY = 'Third Party',
  THIRD_PARTY_FIRE_THEFT = 'Third Party (Fire/Theft)',
  COMPREHENSIVE_85 = 'Comprehensive 85%',
  COMPREHENSIVE_90 = 'Comprehensive 90%',
  COMPREHENSIVE_100 = 'Comprehensive 100%',
  SMART_DRIVE = 'Smart Drive'
}

export enum PREMIUM_FINANCING_VEHICLES_COVER_TYPES {
  COMPREHENSIVE_85 = 'COMPREHENSIVE_85',
  COMPREHENSIVE_90 = 'COMPREHENSIVE_90',
  COMPREHENSIVE_100 = 'COMPREHENSIVE_100',

}

export enum SESSION_PERIOD {
  FIFTEEN_MINUTES = "15 minutes",
  THIRTY_MINUTES = "30 minutes",
  ONE_HOUR = "1 hour",
  TWO_HOURS = "2 hours",
  EIGHT_HOURS = "8 hours",
}

export enum DISBURSEMENT_STATUS {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  PARTIAL = "PARTIAL",
  PROCESSING = "PROCESSING",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED"
}

export enum TRANSACTION_STATUS {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  PARTIAL = "PARTIAL",
  PROCESSING = "PROCESSING",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED"
}

export enum TRANSACTION_TYPE {
  ADJUSTMENT = "ADJUSTMENT",
  CLAIM_PAYMENT = "CLAIM_PAYMENT",
  COMMISSION_PAYMENT = "COMMISSION_PAYMENT",
  COMMISSION_REFUND = "COMMISSION_REFUND",
  DEPOSIT = "DEPOSIT",
  DISBURSEMENT = "DISBURSEMENT",
  LOAN_DISBURSEMENT = "LOAN_DISBURSEMENT",
  LOAN_REPAYMENT = "LOAN_REPAYMENT",
  OTHER = "OTHER",
  PLATFORM_FEE = "PLATFORM_FEE",
  POLICY_CANCELLATION_REFUND = "POLICY_CANCELLATION_REFUND",
  PREMIUM_PAYMENT = "PREMIUM_PAYMENT",
  PREMIUM_REFUND = "PREMIUM_REFUND",
  SERVICE_FEE = "SERVICE_FEE",
  TAX_PAYMENT = "TAX_PAYMENT",
  WITHDRAWAL = "WITHDRAWAL"
}

export enum INTERMEDIARY_TYPES {
  AGENT = 'AGENT',
  BANCASSURANCE = 'BANCASSURANCE',
  BROKER = 'BROKER',
  DIGITAL = 'DIGITAL'
}

export enum PERMISSIONS {
  CAN_VIEW_DASHBOARD_SALES_CHANNEL_DONUT = "CAN_VIEW_DASHBOARD_SALES_CHANNEL_DONUT",
  CAN_VIEW_DASHBOARD_ACCOUNT_METRICS = "CAN_VIEW_DASHBOARD_ACCOUNT_METRICS",
  CAN_INVITE_TEAM_USERS = "CAN_INVITE_TEAM_USERS",
  CAN_CREATE_QUOTES = "CAN_CREATE_QUOTES",
  CAN_VIEW_TRANSACTION = "CAN_VIEW_TRANSACTION",
  CAN_VIEW_TEAM_PAYOUT_DETAILS = "CAN_VIEW_TEAM_PAYOUT_DETAILS",
  CAN_EDIT_SETTLEMENT_ACCOUNT = "CAN_EDIT_SETTLEMENT_ACCOUNT",
  CAN_CREATE_TEAMS = "CAN_CREATE_TEAMS",
  CAN_VIEW_TEAM_SETTINGS = "CAN_VIEW_TEAM_SETTINGS",
  CAN_ADD_FUEL_TRANSACTION = "CAN_ADD_FUEL_TRANSACTION",
  CAN_APPROVE_TEAM_PAYOUTS = "CAN_APPROVE_TEAM_PAYOUTS",
  CAN_CREATE_TRANSACTION = "CAN_CREATE_TRANSACTION",
  CAN_VIEW_TEAMS = "CAN_VIEW_TEAMS",
  CAN_VIEW_POLICY_PAYMENTS = "CAN_VIEW_POLICY_PAYMENTS",
  CAN_CANCEL_POLICIES = "CAN_CANCEL_POLICIES",
  CAN_REASSIGN_POLICIES = "CAN_REASSIGN_POLICIES",
  CAN_VIEW_POLICY_OWNER_DOCUMENTS = "CAN_VIEW_POLICY_OWNER_DOCUMENTS",
  CAN_VIEW_NOTIFICATION_SETTINGS = "CAN_VIEW_NOTIFICATION_SETTINGS",
  CAN_VIEW_POLICY_VEHICLE_PHOTOS = "CAN_VIEW_POLICY_VEHICLE_PHOTOS",
  CAN_DELETE_VOUCHERS = "CAN_DELETE_VOUCHERS",
  CAN_DELETE_ROLES_PERMISSIONS = "CAN_DELETE_ROLES_PERMISSIONS",
  CAN_VIEW_BUSINESS_SETTINGS = "CAN_VIEW_BUSINESS_SETTINGS",
  CAN_ADD_FLEET_VEHICLE = "CAN_ADD_FLEET_VEHICLE",
  CAN_VIEW_DEVELOPER_SETTINGS = "CAN_VIEW_DEVELOPER_SETTINGS",
  CAN_DELETE_TRANSACTION = "CAN_DELETE_TRANSACTION",
  CAN_EDIT_CLAIMS = "CAN_EDIT_CLAIMS",
  CAN_CREATE_VEHICLES = "CAN_CREATE_VEHICLES",
  CAN_ONBOARD_RIDE_SHARING_DRIVER = "CAN_ONBOARD_RIDE_SHARING_DRIVER",
  CAN_CREATE_COMMUNITY = "CAN_CREATE_COMMUNITY",
  CAN_VIEW_RIDE_SHARING_DRIVERS = "CAN_VIEW_RIDE_SHARING_DRIVERS",
  CAN_VIEW_TEAM_PAYOUT = "CAN_VIEW_TEAM_PAYOUT",
  CAN_VIEW_PAYMENTS = "CAN_VIEW_PAYMENTS",
  CAN_VIEW_POLICY_VEHICLE_DOCUMENTS = "CAN_VIEW_POLICY_VEHICLE_DOCUMENTS",
  CAN_VIEW_SETTLEMENT_ACCOUNT = "CAN_VIEW_SETTLEMENT_ACCOUNT",
  CAN_VIEW_DASHBOARD_FINANCIALS = "CAN_VIEW_DASHBOARD_FINANCIALS",
  CAN_UPDATE_POLICIES = "CAN_UPDATE_POLICIES",
  CAN_EDIT_TRANSACTION = "CAN_EDIT_TRANSACTION",
  CAN_EDIT_DEVELOPER_SETTINGS = "CAN_EDIT_DEVELOPER_SETTINGS",
  CAN_VIEW_RIDE_SHARING_ANALYTICS = "CAN_VIEW_RIDE_SHARING_ANALYTICS",
  CAN_VIEW_CUSTOMER_POLICY = "CAN_VIEW_CUSTOMER_POLICY",
  CAN_EDIT_INSURERS = "CAN_EDIT_INSURERS",
  CAN_VIEW_VOUCHERS = "CAN_VIEW_VOUCHERS",
  CAN_SET_TEAM_RELATIONSHIP_MANAGER = "CAN_SET_TEAM_RELATIONSHIP_MANAGER",
  CAN_VIEW_FLEET_REPORTS = "CAN_VIEW_FLEET_REPORTS",
  CAN_EDIT_TEAM_SETTINGS = "CAN_EDIT_TEAM_SETTINGS",
  CAN_VIEW_PAYOUTS = "CAN_VIEW_PAYOUTS",
  CAN_EDIT_LEADS = "CAN_EDIT_LEADS",
  CAN_VIEW_CUSTOMERS = "CAN_VIEW_CUSTOMERS",
  CAN_CREATE_ROLES_PERMISSIONS = "CAN_CREATE_ROLES_PERMISSIONS",
  CAN_VIEW_DASHBOARD_MARKETING_METRICS = "CAN_VIEW_DASHBOARD_MARKETING_METRICS",
  CAN_VIEW_FLEET = "CAN_VIEW_FLEET",
  CAN_VIEW_QUOTES = "CAN_VIEW_QUOTES",
  CAN_GENERATE_TEAM_PAYOUT = "CAN_GENERATE_TEAM_PAYOUT",
  CAN_EDIT_POLICIES = "CAN_EDIT_POLICIES",
  CAN_EDIT_NOTIFICATION_SETTINGS = "CAN_EDIT_NOTIFICATION_SETTINGS",
  CAN_VIEW_FUEL_REPORTS = "CAN_VIEW_FUEL_REPORTS",
  CAN_MANAGE_FUEL_VENDORS = "CAN_MANAGE_FUEL_VENDORS",
  CAN_VIEW_LEADS = "CAN_VIEW_LEADS",
  CAN_VIEW_TEAM_MEMBER_DETAILS = "CAN_VIEW_TEAM_MEMBER_DETAILS",
  CAN_ACTIVATE_TEAM_MEMBERS = "CAN_ACTIVATE_TEAM_MEMBERS",
  CAN_REMOVE_FLEET_VEHICLE = "CAN_REMOVE_FLEET_VEHICLE",
  CAN_REMOVE_TEAM_MEMBER = "CAN_REMOVE_TEAM_MEMBER",
  CAN_EDIT_VOUCHERS = "CAN_EDIT_VOUCHERS",
  CAN_VIEW_TEAM_COMMISSIONS = "CAN_VIEW_TEAM_COMMISSIONS",
  CAN_VIEW_INSURERS = "CAN_VIEW_INSURERS",
  CAN_EDIT_SECURITY_SETTINGS = "CAN_EDIT_SECURITY_SETTINGS",
  CAN_CHANGE_TEAM_MEMBER_ACCESS = "CAN_CHANGE_TEAM_MEMBER_ACCESS",
  CAN_VIEW_TEAM_MEMBERS = "CAN_VIEW_TEAM_MEMBERS",
  CAN_VIEW_DASHBOARD_SALES_MIX_DONUT = "CAN_VIEW_DASHBOARD_SALES_MIX_DONUT",
  CAN_VIEW_TEAM_PERFORMANCE = "CAN_VIEW_TEAM_PERFORMANCE",
  CAN_EDIT_SALES = "CAN_EDIT_SALES",
  CAN_VIEW_DASHBOARD_LEAD_DONUT = "CAN_VIEW_DASHBOARD_LEAD_DONUT",
  CAN_EDIT_ROLES_PERMISSIONS = "CAN_EDIT_ROLES_PERMISSIONS",
  CAN_REVIEW_POLICIES = "CAN_REVIEW_POLICIES",
  CAN_CREATE_INSURERS = "CAN_CREATE_INSURERS",
  CAN_SET_TEAM_COMMISSION_RATE = "CAN_SET_TEAM_COMMISSION_RATE",
  CAN_INVITE_TEAM_MEMBERS = "CAN_INVITE_TEAM_MEMBERS",
  CAN_APPROVE_POLICIES = "CAN_APPROVE_POLICIES",
  CAN_VIEW_PROFILE_SETTINGS = "CAN_VIEW_PROFILE_SETTINGS",
  CAN_VIEW_ROLES_PERMISSIONS = "CAN_VIEW_ROLES_PERMISSIONS",
  CAN_VIEW_POLICIES = "CAN_VIEW_POLICIES",
  CAN_EDIT_COMMUNITY = "CAN_EDIT_COMMUNITY",
  CAN_VIEW_VEHICLES = "CAN_VIEW_VEHICLES",
  CAN_VIEW_COMMUNITY = "CAN_VIEW_COMMUNITY",
  CAN_MANAGE_FLEET_DRIVERS = "CAN_MANAGE_FLEET_DRIVERS",
  CAN_VIEW_FUEL_TRANSACTIONS = "CAN_VIEW_FUEL_TRANSACTIONS",
  CAN_VIEW_CLAIMS = "CAN_VIEW_CLAIMS",
  CAN_REVIEW_TEAM_PAYOUTS = "CAN_REVIEW_TEAM_PAYOUTS",
  CAN_CREATE_VOUCHERS = "CAN_CREATE_VOUCHERS",
  CAN_EDIT_BUSINESS_SETTINGS = "CAN_EDIT_BUSINESS_SETTINGS",
  CAN_VIEW_DASHBOARD_SALES_AMOUNT_DONUT = "CAN_VIEW_DASHBOARD_SALES_AMOUNT_DONUT",
  CAN_VIEW_DASHBOARD_POLICY_SALES = "CAN_VIEW_DASHBOARD_POLICY_SALES",
  CAN_EDIT_TEAMS = "CAN_EDIT_TEAMS",
  CAN_ADD_TEAM_MEMBER = "CAN_ADD_TEAM_MEMBER",
  CAN_VIEW_SALES = "CAN_VIEW_SALES",
  CAN_CREATE_LEADS = "CAN_CREATE_LEADS",
  CAN_PERFORM_POLICY_ACTIONS = "CAN_PERFORM_POLICY_ACTIONS"
}

export enum INSTALLMENT_PERIODS {
  FULL_PAYMENT = "FULL_PAYMENT",
  SEVENTY_DAYS = "SEVENTY_DAYS",
  NINE_WEEKS = "NINE_WEEKS",
  TEN_WEEKS = "TEN_WEEKS",
  TWELVE_WEEKS = "TWELVE_WEEKS",
  THREE_MONTHS = "THREE_MONTHS",
  SIX_MONTHS = "SIX_MONTHS",
  NINE_MONTHS = "NINE_MONTHS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  THREE_DAYS_TEST = "THREE_DAYS_TEST",
  FORTY_DAYS = "FORTY_DAYS",
  SIXTY_DAYS = "SIXTY_DAYS",
  ONE_HUNDRED_AND_TWENTY_DAYS = "ONE_HUNDRED_AND_TWENTY_DAYS",
  DAILY = "DAILY",
  NINETY_DAYS = "NINETY_DAYS",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

export enum POLICY_ISSUANCE_MODES {
  INSURER_API = "INSURER_API",
  MID_LIVE = "MID_LIVE",
  EMAIL = "EMAIL",
  OFFLINE = "OFFLINE"
}

export enum NON_MOTOR_POLICY_TYPES {
  HOME = "HOME",
  TRAVEL = "TRAVEL",
  HEALTH = "HEALTH",
  LIFE = "LIFE",
  BUSINESS = "BUSINESS",
  MARINE = "MARINE",
  FIRE = "FIRE",
  PERSONAL_ACCIDENT = "PERSONAL_ACCIDENT",
  PROFESSIONAL_INDEMNITY = "PROFESSIONAL_INDEMNITY",
  PUBLIC_LIABILITY = "PUBLIC_LIABILITY",
  ASSET_ALL_RISK = "ASSET_ALL_RISK",
  GOODS_IN_TRANSIT = "GOODS_IN_TRANSIT",
  MONEY_INSURANCE = "MONEY_INSURANCE",
  FIDELITY_GUARANTEE = "FIDELITY_GUARANTEE",
  PETROLEUM_BOND = "PETROLEUM_BOND",
  GROUP_PERSONAL_ACCIDENT = "GROUP_PERSONAL_ACCIDENT",
  PLANT_AND_MACHINERY = "PLANT_AND_MACHINERY",
  CUSTOMS_REMOVAL_BOND = "CUSTOMS_REMOVAL_BOND",
  PERFORMANCE_BOND = "PERFORMANCE_BOND",
  BID_BOND = "BID_BOND",
  WORKMEN_COMPENSATION_POLICY = "WORKMEN'S COMPENSATION POLICY",
  WORKFORCE_INCOME_SECURITY = "WORKFORCE INCOME SECURITY",
  BANKERS_INDEMNITY = "BANKERS INDEMNITY",
  CYBER_LIABILITY = "CYBER_LIABILITY",
  EMPLOYER_LIABILITY = "EMPLOYER_LIABILITY",
  EQUIPMENT_INSURANCE = "EQUIPMENT_INSURANCE",
  ELECTRONIC_EQUIPMENT = "ELECTRONIC_EQUIPMENT",
  FIRE_AND_BURGLARY = "FIRE & BURGLARY",
  CONTRACTORS_ALL_RISK = "CONTRACTORS ALL RISK"
}

export enum CUSTOMER_TYPE {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS"
}